import IOTUtilService from "./IOTUtilService";

const iotUtilService = new IOTUtilService();

export default {
  getListStation: function(params) {
    return iotUtilService.get(`/camera/v2/stations/convert`, {
      params
    });
  },
  getAllStation: function() {
    return iotUtilService.get(`/camera/v2/provinces/stations`);
  },
  getOwnStation: function() {
    return iotUtilService.get(`/camera/v2/stations`);
  },
  // List kho đầy đủ, phân quyền theo V2
  getV2Station: function() {
    return iotUtilService.get(`/device/v1/scale/station`);
  }
};
